import { createApiAction } from '@saucelabs/sl-util-redux';
import { actions as jobActions } from '@saucelabs/sl-module-jobs';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { utils as authUtils } from '@saucelabs/sl-container-authentication';
import { actions as performanceActions } from '@saucelabs/sl-module-performance';
import { parse } from 'qs';

import { actions as historyActions } from '../performanceHistory';
import { INITIALIZE } from './types';
import * as actions from './actions';
import { PERFORMANCE_EVENTS, trackEvent } from './../../tracking';

import { operations } from './index';

/* eslint no-unused-vars: 0 */
export const getJob = (payload, meta) => (dispatch) => (
  dispatch(jobActions.getJob(payload, meta))
    .then(({ data }) => data)
);

export const fetchJob = (payload) => (dispatch) => (
  dispatch(operations.getJob(payload, { skipErrorPage: true }))
    .catch((slError) => (
      dispatch(jobActions.getUPJob(payload))
        .catch((error) => {
          throw slError;
        })
    ))
);

export const initialize = createApiAction(
  INITIALIZE,
  (payload, meta, dispatch, getState) => Promise.all([
    dispatch(operations.fetchJob(payload)),
    dispatch(trackEvent(PERFORMANCE_EVENTS.PERFORMANCE_REPORT_OPEN)),
  ]).then((response) => {
    const state = getState();
    const isAuthenticatedUser = state.user.isAuthenticated();
    const isPublicJob = state.apps.job.job.get('job').isPublic();
    const routerLocation = state.router.location;
    const currentPathname = routerLocation.pathname;
    const qs = parse(routerLocation.search, { ignoreQueryPrefix: true });
    const authInQS = !!qs.auth;
    if ((!isAuthenticatedUser && !authInQS) && !isPublicJob) {
      throw authUtils.redirectToMainLogin(currentPathname);
    }
    return response;
  }),
);

export const onRouteParamsChange = ({
  prevValue, jobId, pageIndex, auth,
}) => (dispatch) => Promise.all([
  dispatch(actions.updatePageIndex(pageIndex)),
  (prevValue.jobId !== jobId ?
    dispatch(operations.initialize({
      id: jobId,
      config: {
        params: { full: true, auth },
      },
    })) :
    dispatch(actions.updateShouldCallInit(false))
  ),
]);

export const changeJobVisibility = ({ id, visibility, username }) => (dispatch) => (
  dispatch(jobActions.changeVisibility({ id, visibility, username }))
    .then(() => dispatch(notificationActions.notifySuccess('Visibility changed')))
    .catch(() => dispatch(notificationActions.notifyDanger(
      'We were not able to change job visibility',
    )))
);

export const cleanup = () => (dispatch) => (
  Promise.all([
    dispatch(performanceActions.cleanup()),
    dispatch(historyActions.cleanup()),
  ])
);
